// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"51":"adcacd53","278":"8cfc836b","329":"65e7f431","453":"a5a1f6d6","775":"946b27fb"}[chunkId] + ".chunk.js";
};